export const getUserAvatar = (user) => {
    const { brand, homeOrganization } = user;
    return (brand?.logoUrl ||
        homeOrganization?.logoUrl ||
        brand?.cdnLogoUrl ||
        homeOrganization?.cdnLogoUrl);
};
